<template>
  <ToggleButton :toggleSidebar="this.toggleSidebar"/>
</template>

<script>
import ToggleButton from "@/components/navigation/menu/utils/ToggleButton";
export default {
  name: "ResponsiveNavButton",
  components: {ToggleButton},
  props: ['loggedin', 'username'],
  computed: {
    //Passing appropriate classes to match the sidebar or topbar navigation collapse functionality
    toggleSidebar() {
      return (this.loggedin && this.username) ? ['sidebar-1', ''] : ['', 'collapse']
    }
  }
}
</script>